module.exports = __webpack_public_path__ + "img/mobile-features-swap.a15d3ab4.svg";